import axios from 'axios';
import { getConfig, getClientId, getMemoryObj } from "./Utils";

// Obtém a URL da API do ambiente
const basePath = "https://kzmiro-api.superlogica.tech/api/";

export async function getLogs() {
  const url = basePath + 'bot/logs?database=' + getConfig()?.database
  try {
    var response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
  }
}

export async function resetTelemetry() {
  const url = basePath + 'bot/telemetry/reset';
  try {
    var response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
  }
}

export async function getTelemetry() {
  const url = basePath + 'bot/telemetry';
  try {
    var response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
  }
}

export async function loadUpdateTime() {
  const url = basePath + 'datasource/time?database=' + getConfig()?.database + (getClientId() ? '&clientId=' + getClientId() : "");
  try {
    var response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
  }
}

export async function loadContexts() {
  const url = basePath + 'scheme/' + getConfig()?.model;
  try {
    var response = await axios.get(url + '/DIM_T');
    sessionStorage.setItem('DIM_T', response.data);
    response = await axios.get(url + '/context');
    sessionStorage.setItem('context', response.data);
  } catch (error) {
    console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
  }
}

export async function getMemory() {
  const url = basePath + 'scheme/' + getConfig()?.model;
  try {
    var response = await axios.get(url + '/memory');
    return response.data;
  } catch (error) {
    console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
  }
}

export async function flowCorp(name) {
  const url = basePath + 'corporation/flow?name=' + name;
  try {
    var response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
  }
}

export async function configCorp(name) {
  const url = basePath + 'corporation/config?name=' + name;
  try {
    var response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
  }
}

export async function login(username, password) {
  const url = basePath + 'corporation/login';
  const headers = { 'Content-Type': 'application/json' };
  const data = {
    "username": username,
    "password": password
  };
  try {
    var response = await axios.post(url, data, { headers });
    return response;
  } catch (error) {
    console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
  }
}

export async function registerMemory(memo) {
    const url = basePath + 'scheme/property';
    const headers = { 'Content-Type': 'application/json' };
    const data = {
      "name": getConfig()?.model,
      "key": "memory",
      "value": memo
    };
    try {
      await axios.post(url, data, { headers });
    } catch (error) {
      console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
    }
    return null;	
}

export async function callAgent(endpoint, scheme, input) {
    const url = basePath + endpoint;
    const headers = { 'Content-Type': 'application/json' };
    const data = {
      "scheme": scheme,
      "values": [input],
      "args": {
        "today": new Date().toISOString(),
        "memory": getMemoryObj()
      }
    };
    try {
      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
      alert('O GPT morreu. =/ Favor tente novamente.');
    }
    return null;
}

export async function callTool(endpoint, data) {
    const url = basePath + endpoint;
    const headers = { 'Content-Type': 'application/json' };
    try {
      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
      alert('O Motor de cálculo morreu. =/ Favor tente novamente.');
    }
    return null;
}

export async function run(data) {
    const url = basePath + "bot/run";
    const headers = { 'Content-Type': 'application/json' };
    data.args = {
      today: new Date().toISOString(),
      memory: getMemoryObj()
    }
    try {
      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
      alert('O GPT morreu. =/ Favor tente novamente.');
    }
    return null;
}

export async function move(data) {
    const url = basePath + "bot/move";
    const headers = { 'Content-Type': 'application/json' };
    try {
      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      console.error('Erro ao fazer a chamada à API:', error.response ? error.response.data : error.message);
      alert('O GPT morreu. =/ Favor tente novamente.');
    }
    return null;
}